import { atom, PrimitiveAtom } from "jotai"

import { CleanUser } from "../../types/User"

export const userAtom = atom<CleanUser>(null) as PrimitiveAtom<CleanUser>
